import React from "react";
import { Navigate } from "react-router-dom";
import { getStoredCalendarState } from "../../utils/calendarStorage";

interface CalendarRedirectProps {
  /** When true, redirects to calendar/{view}. When false, redirects to {view} (for calendar index). */
  includeCalendarPath?: boolean;
}

/**
 * Redirects to the stored calendar view (or daily by default).
 * Used when user navigates to /appointments or /appointments/calendar without a view.
 */
const CalendarRedirect: React.FC<CalendarRedirectProps> = ({
  includeCalendarPath = true,
}) => {
  const stored = getStoredCalendarState();
  const view = stored?.view ?? "daily";
  const to = includeCalendarPath ? `calendar/${view}` : view;
  return <Navigate to={to} replace />;
};

export default CalendarRedirect;
